import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {clientsGetAction, clientBlockAction, clientArchiveAction, clientDelAction, clientUnbanChatMemberAction, clientCheckChatMemberAction, aiBatchGetAction, clientChannelAction} from "../../actions/clientAction";
import {ChatAiBatchReview} from "./utils/ChatAiBatchReview";
import {toast} from "react-toastify";
import {
  formatErrors,
  roleTechnicalSpecialist,
  UPDATE_CHAT_CLIENT_DATA,
  UPDATE_CHAT_CLIENT_RELOAD,
  roleAdmin,
  userPrintName,
  UPDATE_CHAT_CLIENT_CURATOR_DATA,
  UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER,
  roleChiefNutritionist,
  roleCurator,
  newAiUiEnabled
} from "../../constants";
import cfg from "../../constants";
import {i_more} from "../../icons";
import {ClientDiseases} from "./utils/ClientDiseases";
import {ClientNote} from "./utils/ClientNote";
import {Loader} from "../../utils/loader/Loader";
import {Age} from "../../utils/dateFormat/Age";
import {PeriodDay} from "../../utils/dateFormat/PeriodDay";
import {ClientEditModal} from "../clients/utils/ClientEditModal";
import {ClientDatesEditModal} from "../clients/utils/ClientDatesEditModal";
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {UPDATE_CHAT_CLIENT_ID} from "../../constants";
import {ClientsCuratorOnPageModal} from "../clients/utils/ClientsCuratorOnPageModal";
import {curatorsAction} from '../../actions/usersAction';
import { ClientMergeMaxModal } from '../clients/utils/ClientMergeMaxModal';

const ChatClient = (props) => {
  const [loading, setLoading] = useState(null);
  const clientID = useSelector(state => state.chat.clientID);
  const client = useSelector(state => state.chat.client);
  const clientReload = useSelector(state => state.chat.clientReload);
  const course = useSelector(state => state.chat.course);
  const user = useSelector(state => state.user.profile);
  const dispatch = useDispatch();
  const curator = useSelector(state => state.chat.curator);
  const [users, setUsers] = useState([]);
  const blockInChatBoltalokIdList = useSelector(state => state.chat.block_in_chat_boltalok_id_list);
  const aiBatch = useSelector(state => state.chat.aiBatch);
  const [clientTab, setClientTab] = useState('profile');

  const handleBlock = () => {
    if (loading) {
      return;
    }
    setLoading('status');
    const block_clients = client.block_clients ? false : true;
    dispatch(clientBlockAction(client.id, block_clients)).then(() => {
      setLoading(false);
      dispatch({type: UPDATE_CHAT_CLIENT_DATA, client: {block_clients: block_clients}});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleArchive = () => {
    if (loading) {
      return;
    }
    setLoading('status');
    const archive = client.archive ? false : true;
    dispatch(clientArchiveAction(client.id, archive)).then(() => {
      setLoading(false);
      dispatch({type: UPDATE_CHAT_CLIENT_DATA, client: {archive: archive}});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const onClientChanged = (data) => {
    dispatch({type: UPDATE_CHAT_CLIENT_DATA, client: data});
  };

  const onClientCuratorChanged = (data) => {
    dispatch({type: UPDATE_CHAT_CLIENT_CURATOR_DATA, curator: data});
  };

  const onCourseChanged = () => {
    dispatch({type: UPDATE_CHAT_CLIENT_RELOAD});
  };

  const handleDel = () => {
    if (loading) {
      return;
    }
    setLoading('status');
    dispatch(clientDelAction(client.id)).then(() => {
      setLoading(false);
      dispatch({type: UPDATE_CHAT_CLIENT_ID})
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleClientUnbanChatMember = () => {
    if (loading) {
      return;
    }
    setLoading('status');
    
    dispatch(clientUnbanChatMemberAction(client.id, blockInChatBoltalokIdList)).then(() => {
      setLoading(false);
      dispatch({type: UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER, block_in_chat_boltalok_id_list: []});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleClientCheckChatMember = () => {
    if (loading) {
      return;
    }
    setLoading('status');
    
    dispatch(clientCheckChatMemberAction(client.id)).then((data) => {
      setLoading(false);
      dispatch({type: UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER, block_in_chat_boltalok_id_list: data.block_in_chat_boltalok_id_list});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleChannelChange = (newType) => {
    if (loading) {
      return;
    }
    setLoading('status');
    dispatch(clientChannelAction(client.id, newType)).then(() => {
      setLoading(false);
      dispatch({type: UPDATE_CHAT_CLIENT_DATA, client: {channel_type: newType}});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    if (!clientID) {
      return;
    }
    setClientTab('profile');
    setLoading(true);
    dispatch(clientsGetAction(clientID)).then(() => {
      setLoading(false);
    }).catch((e) => {
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      setLoading(false);
    });
  }, [clientID, dispatch]);

  useEffect(() => {
    if (!clientReload || !clientID) {
      return;
    }
    setLoading(true);
    dispatch(clientsGetAction(clientID)).then(() => {
      setLoading(false);
    }).catch((e) => {
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      setLoading(false);
    });
  }, [clientReload, clientID, dispatch]);

  const clientAiId = client && client.enable_ai && user && user.enable_ai ? client.id : null;

  // Depend on the id, not on the client object: it is recreated on any UPDATE_CHAT_CLIENT_DATA
  // (block, archive, channel change, health save), which made this effect refetch the batch.
  // An already answered suggestion came back as a card and was sent to the client twice.
  useEffect(() => {
    if (!clientAiId) {
      return;
    }
    dispatch(aiBatchGetAction(clientAiId)).then((data) => {
      if (data && !newAiUiEnabled()) {
        setClientTab('ai');
      }
    });
  }, [clientAiId, dispatch]);

  useEffect(() => {
    dispatch(curatorsAction()).then((data) => {
      let list = [{ key: '', text: 'Все', value: '' }];
      (data || []).forEach((i) => {
        let name = userPrintName(i);
        list.push({key: i.id, text: name, value: i.id, role_id: i.role_id});
      });
      setUsers(list);
    }).catch((e) => {
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  const onAiBatchComplete = () => {
    setClientTab('profile');
  };

  return <aside className="user-info">
    {loading && <Loader size="large" padded/>}
    {client && !loading && <React.Fragment>
      {!newAiUiEnabled() && client.enable_ai && user.enable_ai && aiBatch && <div className="user-info__tabs">
        <ul className="switch__list">
          <li className={"switch__item" + (clientTab === 'ai' ? " switch__item--active" : "")} onClick={() => setClientTab('ai')}>AI ответ</li>
          <li className={"switch__item" + (clientTab === 'profile' ? " switch__item--active" : "")} onClick={() => setClientTab('profile')}>Профиль</li>
        </ul>
      </div>}
      {!newAiUiEnabled() && clientTab === 'ai' && client.enable_ai && user.enable_ai && aiBatch && <ChatAiBatchReview aiBatch={aiBatch} clientId={client.id} onComplete={onAiBatchComplete}/>}
      {(newAiUiEnabled() || clientTab === 'profile' || !aiBatch) && <React.Fragment>
      <div className="user-info__wrapper user-info__wrapper--inner">
        <div className="user-info__inner">
          <div className="user-info__ava">
            {client.photo && <img src={cfg.public_url + 'auth/file/' + client.id + '/i/' +  client.photo} alt="" />}
            {!client.photo && <div className="user-info__ava--none">{client.first_name.substring(0, 1)}{client.last_name.substring(0, 1)}</div>}
          </div>
          <div className="user-info__details">
            {!client.first_name && !client.last_name && <div className="user-info__name">{client.username_telegram}</div>}
            {(client.first_name || client.last_name) && <div className="user-info__name">{client.first_name} {client.last_name}</div>}
            {(client.time || client.city) && <div className="user-info__more">
              {client.time && <span className="user-info__time">{client.time}</span>}
              {client.city && <span className="user-info__city">{client.city}</span>}
            </div>}
            {client.archive && <div className="user-info__status user-info__status--block">В Архиве</div>}
            {!client.archive && client.block_clients && <div className="user-info__status user-info__status--block">Заблокирован</div>}
            {!client.archive && !client.block_clients && <div className="user-info__status user-info__status--active">Активен</div>}
          </div>
          <span className="user-info__act pointer">
            {i_more()}
          </span>
          <ul className="dropdown dropdown--left">
            {!client.archive && <li className="dropdown__item">
              {!client.block_clients && <span className="dropdown__act dropdown__act--block dropdown--link" onClick={handleBlock}>Заблокировать</span>}
              {client.block_clients && <span className="dropdown__act icon-mark dropdown--link" onClick={handleBlock}>Разблокировать</span>}
            </li>}
            {user && user.role_id === roleTechnicalSpecialist && <li className="dropdown__item">
              {!client.archive && <span className="dropdown__act dropdown__act--block dropdown--link dropdown--link__red" onClick={handleArchive}>В Архив</span>}
              {client.archive && <span className="dropdown__act icon-mark dropdown--link dropdown--link__green" onClick={handleArchive}>Из Архива</span>}
            </li>}
            <li className="dropdown__item">
              <ClientEditModal client={client} trigger={<span className="dropdown__act icon-edit dropdown--link">Изменить</span>} handleComplete={onClientChanged} user={user}/>
            </li>
            {user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleChiefNutritionist) && <li className="dropdown__item">
                <ClientsCuratorOnPageModal users={users} client={client} trigger={<span className="dropdown__act icon-edit dropdown--link">Изменить куратора</span>} handleComplete={onClientCuratorChanged}/>
            </li>}
            {user && (user.role_id === roleTechnicalSpecialist) && <li className="dropdown__item">
              <ClientEditModal client={client} trigger={<span className="dropdown__act icon-edit dropdown--link">Изменить ID телеграм</span>} handleComplete={onClientChanged} user={user} isEditTelegramId={true}/>
            </li>}
            {user && (user.role_id === roleTechnicalSpecialist) && <li className="dropdown__item">
              <ClientEditModal client={client} trigger={<span className="dropdown__act icon-edit dropdown--link">Изменить ID Макс</span>} handleComplete={onClientChanged} user={user} isEditMaxUserId={true}/>
            </li>}
            {user && (user.role_id === roleTechnicalSpecialist) && <li className="dropdown__item">
              <ClientEditModal client={client} trigger={<span className="dropdown__act icon-edit dropdown--link">Изменить ID VK</span>} handleComplete={onClientChanged} user={user} isEditVKUserId={true}/>
            </li>}
            {client.channel_type && client.channel_type !== 'M' && user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleAdmin || user.role_id === roleCurator) && <li className="dropdown__item">
              <ConfirmModal trigger={<span className="dropdown__act dropdown--link">Сменить канал на Макс</span>} triggerWrap={false} title={"Переключить канал на Макс?"} handleOk={() => handleChannelChange('M')}/>
            </li>}
            {client.channel_type && client.channel_type !== 'T' && user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleAdmin || user.role_id === roleCurator) && <li className="dropdown__item">
              <ConfirmModal trigger={<span className="dropdown__act dropdown--link">Сменить канал на Телеграм</span>} triggerWrap={false} title={"Переключить канал на Телеграм?"} handleOk={() => handleChannelChange('T')}/>
            </li>}
            {client.channel_type && client.channel_type !== 'V' && user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleAdmin || user.role_id === roleCurator) && <li className="dropdown__item">
              <ConfirmModal trigger={<span className="dropdown__act dropdown--link">Сменить канал на ВК</span>} triggerWrap={false} title={"Переключить канал на ВК?"} handleOk={() => handleChannelChange('V')}/>
            </li>}
            {(client.channel_type === 'T' || client.channel_type === 'M') && user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleAdmin || user.role_id === roleCurator) && <li className="dropdown__item">
              <ClientMergeMaxModal clientId={client.id} trigger={<span className="dropdown__act dropdown--link" style={{display: 'block'}}>Склеить клиентов с<br /> переключением канала</span>} handleComplete={onClientChanged}/>
            </li>}
            <li className="dropdown__item">
              {!blockInChatBoltalokIdList && <span className="dropdown__act dropdown--link" onClick={handleClientCheckChatMember}>Проверить доступ к чатам</span>}
              {blockInChatBoltalokIdList && blockInChatBoltalokIdList.length === 0 && <span className="dropdown__act icon-mark dropdown--link dropdown--link__green">Болталка доступна</span>}
              {blockInChatBoltalokIdList && blockInChatBoltalokIdList.length !== 0 && <span className="dropdown__act dropdown__act--block dropdown--link dropdown--link__red" onClick={handleClientUnbanChatMember}>Разблокировать в болталке</span>}
            </li>
            {user && user.role_id === roleTechnicalSpecialist && <li className="dropdown__item">
              <ConfirmModal trigger={<span className="dropdown__act dropdown__act--block dropdown--link dropdown--link__red">Удалить</span>} triggerWrap={false} title={"Удалить клиента?"} handleOk={() => handleDel()}/>
            </li>}
          </ul>
        </div>
      </div>
      {client.phone && <div className="user-info__wrapper user-info__wrapper--cols">
        <div className="user-info__col">
          <p className="help">Телефон</p>
          <span className="user-info__text">{client.phone} 
              {user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleAdmin) && <a href={"https://lms.vesbalans.ru/pl/user/user?uc[phone]="+client.phone} target="_blank"><img src="/img/free-icon-crm-1006810.png" className="icon-crm" /></a>}
          </span>
        </div>
        {client.channel_type && <div className="user-info__col">
          <p className="help">Канал</p>
          <span className="user-info__text">
            {client.channel_type === 'T' ? 'Телеграм' : (client.channel_type === 'M' ? 'Макс' : client.channel_type === 'V' ? 'ВК' : 'Неизвестно')}
          </span>
        </div>}
      </div>}
      {user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleAdmin || client.curator_id_temp) && curator.first_name && <div className="user-info__wrapper">
        <p className="help">Куратор</p>
        <span className="user-info__text">{curator.first_name} {curator.last_name} {curator.patronymic_name}</span>
      </div>}
      {course && course.product_title !== "" && <div className="user-info__wrapper">
        <p className="help">Ступень</p>
        <p className="user-info__text"><PeriodDay course={course} /></p>
      </div>}
      <div className="user-info__wrapper user-info__wrapper--padding">
        {client.birthday && <div className="user-info__characters">
          <span className="user-info__years"><Age date={client.birthday}/></span>
        </div>}
        {client.weight > 0 && <div className="user-info__characters">
          <div className="user-info__road">
            <div className="user-info__dynamic">
              <span className="user-info__dynamic--old">{client.weight} кг</span>
              <span className="user-info__dynamic--new">{client.weight_target} кг {client.weight_prev ? "(" + (+(client.weight - client.weight_prev).toFixed(2)) + ")" : ""}</span>
            </div>
            <span className="user-info__link">Динамика</span>
          </div>
        </div>}
        <ClientDiseases client={client} handleChange={onClientChanged}/>
      </div>
      <CourseInfo clientId={client.id} course={course} editable={user.role_id === roleTechnicalSpecialist} handleChange={onCourseChanged}/>
      <ClientNote/>
      </React.Fragment>}

    </React.Fragment>}
  </aside>;
}

function CourseInfo({clientId, course, editable, handleChange}) {
  const [parts, setParts] = useState([false, false, false]);

  useEffect(() => {
    const course_parts = [false, false, false];
    const dt = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2);
    if (course.finish_at && (course.finish_at >= dt || editable)) {
      course_parts[0] = true;
    }
    if (course.finish_at_part2 && (course.finish_at_part2 >= dt || editable)) {
      course_parts[1] = true;
    }
    if (course.finish_at_part3 && (course.finish_at_part3 >= dt || editable)) {
      course_parts[2] = true;
    }
    setParts(course_parts);
  }, [course, editable]);

  return <React.Fragment>
    {course && course.product_title !== "" && <div className="user-info__wrapper">
      {editable && <ClientDatesEditModal clientId={clientId} course={course} trigger={<span className="user-info__edit edit help pointer">Ред.</span>} handleComplete={handleChange}/>}
      {parts[0] && <p className="help">{course.product_title}</p>}
      {parts[0] && <p className="user-info__text">{course.period_string}</p>}
      {parts[1] && course.product_title_part2 && <p className="help">{course.product_title_part2}</p>}
      {parts[1] && <p className="user-info__text">{course.period_string_part2}</p>}
      {parts[2] && course.product_title_part3 && <p className="help">{course.product_title_part3}</p>}
      {parts[2] && <p className="user-info__text">{course.period_string_part3}</p>}
    </div>}
    {course && course.product_title === "" && <div className="user-info__wrapper">
      <div className="user-info__inner user-info__inner--between">
        <div className="user-info__purchases">Нет покупки</div>
        <span className="user-info__btn user-info__btn--accent pointer">Проверить оплату</span>
      </div>
    </div>}
  </React.Fragment>;
}

export default ChatClient
